import React from 'react';
import { Tag } from 'lucide-react';
import { CartItem } from '../../context/CartContext';
import { AppliedPromocode } from '../../context/CartContext';

interface CheckoutReviewProps {
  formData: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    shippingMethod: string;
    address?: {
      street: string;
      city: string;
      postalCode: string;
    };
    paymentMethod: string;
  };
  items: CartItem[];
  subtotal: number;
  shipping: number;
  total: number;
  appliedPromocode: AppliedPromocode | null;
}

export function CheckoutReview({ formData, items, subtotal, shipping, total, appliedPromocode }: CheckoutReviewProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Tellimuse ülevaade</h2>
      
      <div className="space-y-4">
        <div className="border-b pb-4">
          <h3 className="font-semibold mb-2">Kontaktandmed</h3>
          <p>{formData.firstName} {formData.lastName}</p>
          <p>{formData.email}</p>
          <p>{formData.phone}</p>
        </div>
        
        <div className="border-b pb-4">
          <h3 className="font-semibold mb-2">Transport</h3>
          <p>{formData.shippingMethod}</p>
          {formData.address && (
            <p className="text-sm text-gray-600 mt-1">
              {formData.address.street}, {formData.address.city}, {formData.address.postalCode}
            </p>
          )}
        </div>
        
        <div className="border-b pb-4">
          <h3 className="font-semibold mb-2">Makseviis</h3>
          <p>{formData.paymentMethod}</p>
        </div>
        
        <div className="border-b pb-4">
          <h3 className="font-semibold mb-2">Tellimuse sisu</h3>
          {items.map((item, index) => (
            <div key={index} className="flex items-center py-2">
              <img 
                src={item.image} 
                alt={item.name} 
                className="w-16 h-16 object-cover rounded mr-4"
              />
              <div className="flex-1">
                <p className="font-medium">{item.name}</p>
                <p className="text-sm text-gray-600">Kogus: {item.quantity}</p>
              </div>
              <p className="font-medium">{(item.price * item.quantity).toFixed(2)}€</p>
            </div>
          ))}
        </div>
        
        <div>
          <div className="flex justify-between py-2">
            <span>Vahesumma:</span>
            <span>{subtotal.toFixed(2)}€</span>
          </div>
          {appliedPromocode && (
            <div className="flex justify-between py-2 text-green-600">
              <div className="flex items-center">
                <Tag className="w-4 h-4 mr-1" />
                <span>Sooduskood ({appliedPromocode.code}):</span>
              </div>
              <span>-{appliedPromocode.discountAmount.toFixed(2)}€</span>
            </div>
          )}
          <div className="flex justify-between py-2">
            <span>Transport:</span>
            <span className="text-green-600 font-medium">TASUTA</span>
          </div>
          <div className="flex justify-between py-2 font-semibold">
            <span>Kokku:</span>
            <span>{total.toFixed(2)}€</span>
          </div>
        </div>
      </div>
    </div>
  );
}